import { useEffect, useRef, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { getApiUrl } from '../utils/api';
import { AuthContext } from '../utils/AuthContext';

// Don't log page views on public/auth screens.
const SKIP_PREFIXES = ['/', '/create-account', '/forgot-password', '/unauthorized'];

const ActivityTracker = () => {
    const location = useLocation();
    const { user } = useContext(AuthContext);
    const lastPath = useRef(null);

    useEffect(() => {
        if (!user) return;
        const path = location.pathname;

        // exact public matches ('/' handled explicitly so we don't skip everything)
        if (path === '/' || SKIP_PREFIXES.includes(path)) return;
        if (lastPath.current === path) return; // dedupe repeated renders
        lastPath.current = path;

        // fire-and-forget; never block navigation, never surface errors
        axios.post(getApiUrl('/activity/pageview'), { path }).catch(() => { });
    }, [location.pathname, user]);

    return null;
};

export default ActivityTracker;